import { useTranslation } from 'react-i18next';
import { type MyInfoModuleSpecsFragment } from '../../../../../api/fragments/MyInfoModuleSpecs';
import {
    CreateMyInfoModuleDocument,
    type CreateMyInfoModuleMutation,
    type CreateMyInfoModuleMutationVariables,
} from '../../../../../api/mutations/createMyInfoModule';
import { type MyInfoModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import MyInfoModulePage, { type MyInfoModulePageProps } from '../../MyInfoModule';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<MyInfoModuleSpecsFragment, MyInfoModuleSettings> = {
    PageComponent: ({ module }: MyInfoModulePageProps) => <MyInfoModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.MyInfoModule.className'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    getValidator: () => validators.compose(validators.requiredNonEmptyString('displayName')),
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateMyInfoModuleMutation, CreateMyInfoModuleMutationVariables>({
                mutation: CreateMyInfoModuleDocument,
                variables: { companyId, settings: values },
            })
            .then(({ data }) => data.module),
};

export default implementation;
